/* eslint-disable max-lines */
export const config = {
    name: 'tycMapReport',
    searchFields: [
        {
            name: '数据类型',
            value: 'tycChangeType',
            type: 'select',
            optionNum: 'TYC_CHANGE_TYPE',
            isFixed: true,
            span: 6
        },
        {
            name: '天眼查返回值',
            value: 'tycValue',
            type: 'input',
            isFixed: true,
            span: 6
        },
        {
            name: '映射字典值',
            value: 'dictCode',
            type: 'select',
            options: [],
            isFixed: true,
            span: 6
        }
    ],
    selection: true,
    index: false,
    columns: [
        {
            label: '数据类型',
            prop: 'tycChangeType',
            type: 'slot',
            slot: true,
            editSlot: true,
            mustFill: true,
            optionsKey: 'TYC_CHANGE_TYPE'
        },
        {
            label: '天眼查返回值',
            prop: 'tycValue',
            type: 'input',
            mustFill: true
        },
        {
            label: '映射字典值',
            prop: 'dictCode',
            type: 'slot',
            slot: true,
            editSlot: true,
            mustFill: true
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 100, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: []
    },
    rowEdit: true,
    getAuthRole: () => true,
    rowEnableEdit: (row) => true // 是否编辑
};
